module.exports = __webpack_public_path__ + "img/banner2.8f3a5d05.png";